<template>
	<div class="search">
		<div class="top">
			<img class="logo" src="../../static/img/logo.png" />
			<h5 class="top_tit"><span>|</span> 会员管理系统</h5>
			<router-link class="to_search" to="/search">
				会员查询
			</router-link>
			<router-link class="back" to="/login">
				返回登录
			</router-link>
		</div>
		<div class="con">
			<div class="con_con">
				<h3 class="title"><span></span><strong>会员企业查询</strong></h3>
				<div class="con_con_center">
					<span>单位名称</span>
					<input class="ipt" type="text" @input="temp" v-model="name" placeholder="请输入完整企业名称/会员编号" />
					<button class="btn" @click="search">查询</button>
				</div>
				<div class="con_con_bot">
					<span class="con_con_bot_tit">查询结果</span>
					<p class="p1" v-show="result1">没有找到该企业，您可以输入完整的企业名称或会员编号再次尝试</p>
					<p class="p2" v-show="result2">
						<span class="name">{{name1}}</span>
						<span class="b_code">会员编号：{{code}}</span>
						<span :class="type1==1?'time':'time1'">{{type}}</span>
					</p>
				</div>
			</div>
		</div>
		<bottom></bottom>
	</div>
</template>

<script>
	import Qs from 'qs'
	import bottom from './Bottom'
	export default {
		components: {
			bottom
		},
		data() {
			return {
				name:'',
				result1: false,
				result2: false,
				name1:'',
				code:'',
				type:'',
				type1:''
			};
		},
		created() {},
		mounted() {

		},
		methods: {
			search() {
				if(!this.name){
					this.$toast('您可以输入完整的企业名称或会员编号再次尝试');
					return false;
				};
				var data = {
					'name':this.name
				};
				this.$axios({
					method: 'post',
					url: 'user/checkcompany',
					data: Qs.stringify(data)
				}).then(response => {
					if(response.data.state == 1005) {
						this.result2=false;
						this.result1=true;
						
					} else if(response.data.state == 200){
						if(response.data.Memermsg.status==1){
							this.type1 =1;
							this.type='当前有效会员';
						}else{
							this.type1 =2;
							this.type='待缴费会员';
						};
						this.name1=response.data.Memermsg.name;
						this.code=response.data.Memermsg.serial_number;
						this.result1=false;
						this.result2=true;
					}else{
						this.$toast(response.data.msg);
					}
				});
			},
			temp(){
				if(!this.name){
					this.result1=false;
					this.result2=false;
				};
			},
		}
	}
</script>
<style scoped>
	.search {
		width: 100%;
		height: auto;
		background: #fff;
		font-family: PingFangSC-Medium;
		font-size: 20px;
	}
	
	.top {
		height: 80px;
		position: relative;
	}
	
	.logo {
		width: 211px;
		height: 43px;
		position: absolute;
		top: 16px;
		left: 254px;
	}
	
	.top_tit {
		position: absolute;
		top: 26px;
		left: 480px;
		height: 28px;
		font-weight: bold;
		color: rgba(0, 94, 179, 1);
		line-height: 28px;
	}
	
	.top_tit span {
		height: 17px;
		color: #E8E8E8;
	}
	
	.to_search {
		position: absolute;
		top: 30px;
		right: 349px;
		font-size: 14px;
		font-weight: bold;
		color: rgba(128, 128, 128, 1);
		line-height: 20px;
	}
	
	.back {
		position: absolute;
		top: 30px;
		right: 249px;
		font-size: 14px;
		font-weight: bold;
		color: rgba(128, 128, 128, 1);
		line-height: 20px;
	}
	
	.con {
		border-top: 1px solid rgba(0, 0, 0, 0);
		box-sizing: border-box;
		width: 100%;
		height: 600px;
		background: rgba(246, 248, 249, 1);
		font-size: 14px;
	}
	
	.con_con {
		width: 800px;
		height: 518px;
		background: #fff;
		margin: 39px auto 0;
	}
	
	.title {
		text-align: left;
		height: 54px;
		vertical-align: middle;
		line-height: 54px;
		text-indent: 15px;
		background: #0076FF;
		/*border-bottom: 1px solid #EEEEEE;*/
	}
	
	/*.title span {
		display: inline-block;
		width: 8px;
		height: 20px;
		background: rgba(0, 94, 178, 1);
		margin: 0 11px 0 13px;
		vertical-align: middle;
	}*/
	
	.title strong {
		display: inline-block;
		font-size: 20px;
		line-height: 28px;
		font-family: PingFangSC-Medium;
		font-weight: bold;
		color: #fff;
		/*color: rgba(0, 94, 178, 1);*/
		vertical-align: middle;
	}
	
	.con_con_center {
		height: 174px;
		width: 100%;
		padding: 40px 32px 0;
		box-sizing: border-box;
		color: rgba(64, 64, 64, 1);
	}
	
	.ipt {
		width: 509px;
		height: 40px;
		background: rgba(255, 255, 255, 1);
		border: 1px solid #EEEEEE;
		box-sizing: border-box;
		text-indent: 16px;
		margin: 0 25px 0 10px;
	}
	
	.btn {
		width: 126px;
		height: 40px;
		background: rgba(0, 118, 255, 1);
		border-radius: 4px;
		border: none;
		color: #fff;
		cursor: pointer;
	}
	.btn:hover{
		background: #169BD5;
	}
	.btn:active{
		background: rgba(0, 118, 255, 1);
	}
	.con_con_bot {
		padding-top: 67px;
		width: 654px;
		height: auto;
		border-top: 1px solid #EEEEEE;
		margin-left: 111px;
		position: relative;
	}
	
	.con_con_bot_tit {
		position: absolute;
		top: -10px;
		left: -75px;
	}
	
	.con_con_bot p {
		text-align: left;
	}
	
	.p1 {
		height: 32px;
		line-height: 32px;
		padding-left: 50px;
		background: url(../../static/img/icon8.png) no-repeat top left;
		background-size: 33px 32px;
	}
	
	.p2 {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 35px;
		padding-left: 50px;
		background: url(../../static/img/icon1.png) no-repeat top left;
		background-size: 41px 35px;
		font-size: 14px;
	}
	
	.name {
		width: 200px;
		display: flex;
		align-items: center;
	}
	
	.b_code {
		display: flex;
		align-items: center;
		color: rgba(64, 64, 64, 1);
	}
	.time{
		display: flex;
		align-items: center;
		color: green;
	}
	.time1{
		display: flex;
		align-items: center;
		color: red;
	}
</style>


// WEBPACK FOOTER //
// src/components/Search.vue